<div class="cookie-policy-wrapper">
  <div class="cookie-policy-container">

    <header class="policy-header">
      <h1>Privacy <em>Policy</em></h1>
      <div class="meta">
        <span class="site">wedo.itscocchi.it</span>
        <span class="divider">·</span>
        <span class="date">Ultimo aggiornamento: Marzo 2026</span>
      </div>
    </header>

    <div class="policy-content">

      <section>
        <h2>1. Titolare del trattamento</h2>
        <p>
          Il titolare del trattamento dei dati personali raccolti tramite il sito
          <strong>wedo.itscocchi.it</strong> è il soggetto responsabile di itscocchi.it.
          Per qualsiasi richiesta è possibile contattarci all'indirizzo:
          <strong>info&#64;itscocchi.it</strong>
        </p>
      </section>

      <section>
        <h2>2. Dati raccolti</h2>
        <p>Il sito raccoglie esclusivamente i dati forniti volontariamente dall'utente
          durante la registrazione e l'utilizzo del servizio:</p>
        <ul>
          <li>Nome e cognome</li>
          <li>Indirizzo email</li>
          <li>Dati di accesso (credenziali cifrate)</li>
          <li>Dati inseriti nell'utilizzo del servizio (es. informazioni sul matrimonio)</li>
        </ul>
        <p>Non vengono raccolti dati sensibili, dati di navigazione a scopo di profilazione
          o informazioni di pagamento.</p>
      </section>

      <section>
        <h2>3. Finalità del trattamento</h2>
        <p>I dati personali sono trattati per le seguenti finalità:</p>
        <ul>
          <li>Registrazione e gestione dell'account utente</li>
          <li>Erogazione del servizio e delle sue funzionalità</li>
          <li>Comunicazioni relative al servizio (es. notifiche, aggiornamenti)</li>
          <li>Adempimento di obblighi di legge</li>
        </ul>
      </section>

      <section>
        <h2>4. Base giuridica</h2>
        <p>
          Il trattamento dei dati è basato sul <strong>consenso dell'utente</strong> espresso
          al momento della registrazione e sull'<strong>esecuzione del contratto</strong> di
          servizio, ai sensi dell'art. 6 del Regolamento (UE) 2016/679 (GDPR).
        </p>
      </section>

      <section>
        <h2>5. Conservazione dei dati</h2>
        <p>
          I dati personali sono conservati per il tempo strettamente necessario all'erogazione
          del servizio e comunque non oltre la cancellazione dell'account da parte dell'utente.
          In caso di obblighi di legge, i dati potranno essere conservati per il periodo
          previsto dalla normativa applicabile.
        </p>
      </section>

      <section>
        <h2>6. Condivisione dei dati</h2>
        <p>
          I dati personali <strong>non vengono venduti né ceduti a terzi</strong>. Potranno
          essere comunicati esclusivamente a soggetti che forniscono servizi tecnici
          indispensabili all'erogazione del servizio (es. hosting, infrastruttura cloud),
          i quali operano in qualità di responsabili del trattamento.
        </p>
      </section>

      <section>
        <h2>7. Diritti dell'utente</h2>
        <p>In conformità con il GDPR, l'utente ha il diritto di:</p>
        <ul>
          <li>Accedere ai propri dati personali</li>
          <li>Richiedere la rettifica o la cancellazione dei dati</li>
          <li>Opporsi al trattamento o richiederne la limitazione</li>
          <li>Richiedere la portabilità dei dati</li>
          <li>Revocare il consenso in qualsiasi momento</li>
          <li>Proporre reclamo al Garante per la Protezione dei Dati Personali</li>
        </ul>
        <p>Per esercitare questi diritti è possibile contattarci a <strong>info&#64;itscocchi.it</strong></p>
      </section>

      <section>
        <h2>8. Modifiche alla Privacy Policy</h2>
        <p>
          Il titolare si riserva il diritto di modificare la presente Privacy Policy in
          qualsiasi momento. Le modifiche saranno pubblicate su questa pagina con indicazione
          della data di aggiornamento. Si invita l'utente a consultare periodicamente questa pagina.
        </p>
      </section>

      <div class="policy-footer">
        <p>Questa Privacy Policy è conforme al GDPR (Regolamento UE 2016/679) e alla normativa
          italiana in materia di protezione dei dati personali.</p>
      </div>

    </div>
  </div>
</div>